import React from 'react';
import { BlogSection } from '../components/sections/BlogSection';
export function BlogPage() {
  return <>
      {/* Page Header */}
      <section className="bg-[#0B1F3A] text-white py-20" data-id="element-389">
        <div className="max-w-7xl mx-auto px-4 text-center" data-id="element-390">
          <h1 className="text-4xl lg:text-5xl font-bold mb-6" data-id="element-391">
            Blog & Resources
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-392">
            Stay informed with helpful articles and updates about medical
            transportation
          </p>
        </div>
      </section>

      <BlogSection data-id="element-393" />
    </>;
}